<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Słownik ryzyk'" [name]="'Dodaj'"></app-breadcrumb>
<div class="risk-dictionary-add" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!riskDictionaryForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane słownika</h3>
        </div>

        <div fxLayout="row">
          <mat-form-field fxFlex="100">
            <mat-label>Nazwa</mat-label>
            <input matInput placeholder="Nazwa" [formControl]="nameControl" [required]="true">
            <mat-error *ngIf="nameControl.hasError('required')">To pole jest wymagane</mat-error>
          </mat-form-field>
        </div>

        <div fxLayout="row">
          <app-dict-insurance-companies
            fxFlex="100" label="TU" [required]="true"
            [control]="insuranceCompanyControl"
            (selectedInsuranceCompany)="insuranceCompanyChanged($event)"
            [hideChildren]="true"
          ></app-dict-insurance-companies>
        </div>

        <div fxLayout="row">
          <app-dict
            fxFlex="100"
            [control]="policyTypesControl"
            [multiple]="true"
            dictType="sold_policy_type"
            label="Typ polisy"
          ></app-dict>
        </div>

      </mat-card>
    </div>

  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!riskDictionaryForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
